import React from "react";

interface TransferStatusHeaderProps {
  title: string;
  iconUrl?: string;
}

const TransferStatusHeader = ({ title, iconUrl }: TransferStatusHeaderProps): React.ReactElement => (
  <div className="bwp-transfer-status-header">
    {iconUrl && <img className="bwp-transfer-status-header__icon" src={iconUrl} alt="" />}
    <h1 className="bwp-transfer-status-header__title">{title}</h1>
  </div>
);

export default TransferStatusHeader;